import { render, staticRenderFns } from "./talentAb.vue?vue&type=template&id=60514d42&scoped=true"
import script from "./talentAb.vue?vue&type=script&lang=js"
export * from "./talentAb.vue?vue&type=script&lang=js"
import style0 from "./talentAb.vue?vue&type=style&index=0&id=60514d42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60514d42",
  null
  
)

export default component.exports